import React, { useState } from "react";
import { BoxButton, CDialog, Icon } from "shared";
import InvitePartnerForm from "./InvitePartnerForm";
import { Send } from "assets";
import { useTranslation } from "react-i18next";

const InvitePartner: React.VFC = () => {
  const [isOpen, setOpen] = useState(false);
  const { t } = useTranslation();

  const openDialog = () => setOpen(true);
  const closeDialog = () => setOpen(false);

  return (
    <>
      <BoxButton startIcon={<Icon of={Send} />} onClick={openDialog}>
        {t("form.invite_partner")}
      </BoxButton>

      <CDialog maxWidth="xs" fullWidth open={isOpen} onClose={closeDialog} aria-labelledby="invite-partner">
        <InvitePartnerForm onClose={closeDialog} />
      </CDialog>
    </>
  );
};

export default InvitePartner;
